import Alpine from "alpinejs";

Alpine.data("iconAndText", () => ({
    uuid: null,
    textSize: '',
    iconSize: '',

    configuration: {
        icon: '',
        textColor: '',

        textSize: {
            desktop: '',
            tablet: '',
            mobile: ''
        },

        iconSize: {
            desktop: '',
            tablet: '',
            mobile: ''
        },

        color: {
            normal: '',
            hover: ''
        },

        transform: 'normal',
        iconAndTextGap: '',
        iconsPosition: 'left',
        verticalAlign: 'center',
        horizontalAlign: 'left'
    },

    init(uuid, configuration) {
        if (uuid) {
            this.uuid = uuid;
        }

        if (configuration) {
            this.configuration = configuration;
            this.calculateTextSize();
            this.calculateIconSize();
        }

        // Attach a message listener to reinitialize sliders dynamically
        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-iconAndText') {
                let json = JSON.parse(event.data.data);

                if (json.id === this.uuid) {
                    this.configuration = json.configuration;
                    this.calculateTextSize();
                    this.calculateIconSize();
                }
            }
        });

        const mediaQueries = [
            '(max-width: 767px)',
            '(min-width: 768px) and (max-width: 1024px)',
            '(min-width: 1025px)'
        ];
        mediaQueries.forEach(query =>
            window.matchMedia(query).addEventListener('change', this.calculateTextSize.bind(this))
        );
        mediaQueries.forEach(query =>
            window.matchMedia(query).addEventListener('change', this.calculateIconSize.bind(this))
        );
    },

    calculateTextSize() {
        const config = this.configuration.textSize;

        const desktopSize = config.desktop ? config.desktop + 'px' : '16px'; // Default size if none is set
        const tabletSize = config.tablet ? config.tablet + 'px' : desktopSize; // Fallback to desktop
        const mobileSize = config.mobile ? config.mobile + 'px' : tabletSize; // Fallback to tablet or desktop

        if (window.matchMedia('(max-width: 767px)').matches) {
            // Styles for mobile screens
            this.textSize = mobileSize;
        } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
            // Styles for tablet screens
            this.textSize = tabletSize;
        } else {
            // Styles for desktop screens
            this.textSize = desktopSize;
        }
    },

    calculateIconSize() {
        const config = this.configuration.iconSize;

        // Ensure fallback: mobile <- tablet <- desktop
        const desktopSize = config.desktop ? config.desktop + 'px' : '24px'; // Default size for desktop
        const tabletSize = config.tablet ? config.tablet + 'px' : desktopSize; // Fallback to desktop
        const mobileSize = config.mobile ? config.mobile + 'px' : tabletSize; // Fallback to tablet or desktop

        if (window.matchMedia('(max-width: 767px)').matches) {
            // Styles for mobile screens
            this.iconSize = mobileSize;
        } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
            // Styles for tablet screens
            this.iconSize = tabletSize;
        } else {
            // Styles for desktop screens
            this.iconSize = desktopSize;
        }
    }
}));
